/* Corby's Customs — Theme JS */

document.addEventListener('DOMContentLoaded', function () {

  // ---- HERO SLIDER ----
  const sliders = document.querySelectorAll('.hero-slider');
  sliders.forEach(function (slider) {
    const track = slider.querySelector('.hero-slider__track');
    const slides = slider.querySelectorAll('.hero-slide');
    const dots = slider.querySelectorAll('.hero-dot');
    if (!slides.length) return;
    let current = 0;
    let autoplayTimer = null;
    let isPaused = false;
    const fallbackMs = parseInt(slider.dataset.interval, 10) || 6000;

    // Each slide can have its own duration via data-duration; fall back to section default.
    function durationFor(idx) {
      const d = parseInt(slides[idx].dataset.duration, 10);
      return (isNaN(d) || d < 1000) ? fallbackMs : d;
    }

    function goTo(n) {
      slides[current].classList.remove('is-active');
      if (dots[current]) dots[current].classList.remove('is-active');
      current = (n + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      if (dots[current]) dots[current].classList.add('is-active');
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
    }

    function next() { goTo(current + 1); scheduleNext(); }
    function prev() { goTo(current - 1); scheduleNext(); }

    function scheduleNext() {
      clearTimeout(autoplayTimer);
      if (isPaused) return;
      autoplayTimer = setTimeout(next, durationFor(current));
    }

    slider.querySelector('.hero-arrow--next')?.addEventListener('click', next);
    slider.querySelector('.hero-arrow--prev')?.addEventListener('click', prev);
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { goTo(i); scheduleNext(); });
    });

    slider.addEventListener('mouseenter', function () { isPaused = true;  clearTimeout(autoplayTimer); });
    slider.addEventListener('mouseleave', function () { isPaused = false; scheduleNext(); });

    slides[0].classList.add('is-active');
    if (dots[0]) dots[0].classList.add('is-active');
    scheduleNext();
  });

  // ---- FADE UP OBSERVER ----
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); observer.unobserve(e.target); }
      });
    }, { threshold: 0.1 });
    document.querySelectorAll('.fade-up').forEach(function (el) { observer.observe(el); });
  } else {
    document.querySelectorAll('.fade-up').forEach(function (el) { el.classList.add('is-visible'); });
  }

  // ---- REMEMBERED FITMENT (set by vehicle finder, used across site) ----
  const fit = {
    make:  localStorage.getItem('cc_fit_make'),
    model: localStorage.getItem('cc_fit_model'),
    year:  localStorage.getItem('cc_fit_year')
  };
  if (fit.make && fit.model) {
    document.querySelectorAll('[data-fitment-banner]').forEach(function (el) {
      el.textContent = 'Showing parts for your ' + [fit.year, fit.make, fit.model].filter(Boolean).join(' ');
      el.style.display = '';
    });
    document.querySelectorAll('[data-fitment-confirm]').forEach(function (el) {
      const fits = (el.dataset.fits || '').toLowerCase();
      const key = (fit.make + ' ' + fit.model).toLowerCase();
      if (fits && fits.indexOf(fit.make.toLowerCase()) > -1 && fits.indexOf(fit.model.toLowerCase()) > -1) {
        el.classList.add('is-fit');
        el.textContent = '✓ Confirmed fit for your ' + [fit.year, fit.make, fit.model].filter(Boolean).join(' ');
      } else {
        el.classList.add('is-not-fit');
        el.textContent = '⚠ Not yet made for ' + [fit.year, fit.make, fit.model].filter(Boolean).join(' ') + ' — join the waitlist below';
      }
    });
  }
});
